import * as React from 'react';
import Checkbox from '../../../../../../components/Checkbox/Checkbox';
import { IMaterialDataCheckboxesProps } from './IMaterialDataCheckboxes';
import { useTranslation } from 'react-i18next';
import { CheckForAllMats } from './CheckForAllMats';

const MaterialDataCheckboxes = (props: IMaterialDataCheckboxesProps) => {
    const { t, i18n } = useTranslation();
    return (
        <>
            <div className='d-flex gap-3'>
                <CheckForAllMats />
                {props.isGeotextileFilterVisible && (
                    <Checkbox title={t('material_geotextile')} name='isGeotextileFilter' defaultChecked disabled={!props.isAllowedChangeCheckbox} onChange={props.onChange} />
                )}
                {props.isXTiesVisible && <Checkbox title={t('material_xties')} name='isXties' defaultChecked disabled={!props.isAllowedChangeCheckbox} onChange={props.onChange} />}
                {props.isCastoroVisible && <Checkbox title={t('material_castoro')} name='isCastoro' defaultChecked disabled={!props.isAllowedChangeCheckbox} onChange={props.onChange} />}
            </div>
        </>
    );
};

export default MaterialDataCheckboxes;
